import { Type } from "@sinclair/typebox";
import { Nullable } from "../../utils/typeboxTypes";
export const FcmAppConfigSchema = Type.Object({
    apiKey: Type.String(),
    authDomain: Type.String(),
    projectId: Type.String(),
    storageBucket: Type.String(),
    messagingSenderId: Type.String(),
    appId: Type.String(),
});
export const FcmServiceCredentialsSchema = Type.Object({
    type: Type.String(),
    project_id: Type.String(),
    private_key: Type.String(),
    client_email: Type.String(),
    private_key_id: Type.Optional(Type.String()),
    client_id: Type.Optional(Type.String()),
    auth_uri: Type.Optional(Type.String()),
    token_uri: Type.Optional(Type.String()),
    auth_provider_x509_cert_url: Type.Optional(Type.String()),
    client_x509_cert_url: Type.Optional(Type.String()),
    universe_domain: Type.Optional(Type.String()),
});
export const FcmNotificationChannelConfigSchema = Type.Object({
    appConfig: FcmAppConfigSchema,
    serviceCredentials: FcmServiceCredentialsSchema,
});
export const ApnNotificationChannelConfigSchema = Type.Object({
    p8: Type.String(),
    sandbox: Type.Optional(Type.Boolean()),
    keyId: Type.String(),
    bundleId: Type.String(),
    teamId: Type.String(),
});
export const WebPushNotificationChannelConfigSchema = Type.Object({
    subject: Type.String(),
    publicKey: Type.String(),
    privateKey: Type.String(),
});
export const NotificationChannelConfigSchema = Type.Union([
    FcmNotificationChannelConfigSchema,
    ApnNotificationChannelConfigSchema,
    WebPushNotificationChannelConfigSchema,
]);
export const NotificationChannelServiceSchema = Type.Union([
    Type.Literal("fcm"),
    Type.Literal("apn"),
    Type.Literal("webpush"),
]);
const NotificationChannelBase = Type.Object({
    id: Type.Number(),
    messenger_id: Nullable(Type.Number()),
    config: NotificationChannelConfigSchema,
    is_enabled: Type.Boolean({ default: true }),
    created_at: Nullable(Type.Date({ default: () => new Date() })),
    updated_at: Nullable(Type.Date({ default: () => new Date() })),
    deleted_at: Nullable(Type.Date({ default: () => null })),
}, {
    title: "NotificationChannel",
});
export const MsgrNotificationChannelFcmSchema = Type.Intersect([
    NotificationChannelBase,
    Type.Object({
        service: Type.Literal("fcm"),
        config: FcmNotificationChannelConfigSchema,
    }),
]);
export const MsgrNotificationChannelApnSchema = Type.Intersect([
    NotificationChannelBase,
    Type.Object({
        service: Type.Literal("apn"),
        config: ApnNotificationChannelConfigSchema,
    }),
]);
export const MsgrNotificationChannelWebPushSchema = Type.Intersect([
    NotificationChannelBase,
    Type.Object({
        service: Type.Literal("webpush"),
        config: WebPushNotificationChannelConfigSchema,
    }),
]);
export const MsgrNotificationChannelSchema = Type.Union([
    MsgrNotificationChannelFcmSchema,
    MsgrNotificationChannelApnSchema,
    MsgrNotificationChannelWebPushSchema,
]);
// 1	id	bigint(20)	NULL	NULL	NO	NULL	auto_increment
// 2	platform	varchar(255)	utf8mb4	utf8mb4_unicode_ci	NO	EMPTY
// 3	config	json	NULL	NULL	YES	NULL
// 4	is_enabled	tinyint(4)	NULL	NULL	NO	1
// 5	created_at	datetime	NULL	NULL	YES	NULL
// 6	updated_at	datetime	NULL	NULL	YES	NULL
// 7	deleted_at	datetime	NULL	NULL	YES	NULL
